import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType(); // POP | PUSH | REPLACE
  
  // Helper to remove language prefix (only /en/ or /en at start)
  const getPathWithoutLang = (path) => {
      // If path starts with /en/, remove /en
      if (path.startsWith('/en/')) return path.substring(3);
      // If path is exactly /en, return /
      if (path === '/en') return '/';
      // Otherwise (including /, /about for bs), return path as is
      return path;
  };
  
  const currentPathNoLang = getPathWithoutLang(pathname);
  const prevPathNoLangRef = useRef(currentPathNoLang);

  useEffect(() => {
    const behavior = navigationType === 'POP' ? 'auto' : 'smooth';

    if (navigationType !== 'POP') {
      // Only scroll to top if the actual page content changed,
      // not just the language prefix.
      if (currentPathNoLang !== prevPathNoLangRef.current) {
        window.scrollTo({ top: 0, behavior });
      }
    }
    
    // Update ref for next render
    prevPathNoLangRef.current = currentPathNoLang;
  }, [pathname, navigationType, currentPathNoLang]);

  return null;
};

export default ScrollToTop;
